import React, { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"

export default function PageLoader() {
  const location = useLocation()
  const [loading, setLoading] = useState(false)
  const [width, setWidth] = useState(0)

  useEffect(() => {
    setLoading(true)
    setWidth(0)

    const t1 = setTimeout(() => setWidth(70), 50)
    const t2 = setTimeout(() => setWidth(100), 400)
    const t3 = setTimeout(() => setLoading(false), 700)

    return () => {
      clearTimeout(t1)
      clearTimeout(t2)
      clearTimeout(t3)
    }
  }, [location.pathname])

  if (!loading) return null

  return (
    <div
      className="fixed top-0 left-0 z-[9999] h-0.5 bg-amber-400 transition-all duration-500 ease-out"
      style={{ width: `${width}%` }}
    />
  )
}
